import React from 'react';
import PropTypes from 'prop-types';

import { reduxForm } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { validateStep7 } from './validations';

import { Field } from 'redux-form';
import InputGroup from '../InputGroup';
import Button from '../Button';
import TwoGroup from '../TwoGroup';
import DropDownSelect from '../DropDownSelect';

import {
    Container,
    ButtonGroupWrapper,
    MultipleGroupLastLarge,
    MultipleGroupFull
} from '../../containers/DefaultStyles/FormDetails';

class VoteRegistrationStep7Form extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errors: []
        };
        this.clearSubmitErrors = this.clearSubmitErrors.bind(this);
        this.showAllErrors = this.showAllErrors.bind(this);
        this.checkForBlurError = this.checkForBlurError.bind(this);
    }

    checkForBlurError(name) {
        if (this.props.validationErrors.includes(name) && !this.state.errors.includes(name))
            this.setState({ errors: [...this.state.errors, name] });
    }

    showAllErrors(){
        this.setState({ errors: this.props.validationErrors });
    }

    clearSubmitErrors(fieldName) {
        if (fieldName && this.state.errors.includes(fieldName)) {
            this.setState({ errors: this.state.errors.filter(e => e !== fieldName) });
        }
    }

    render() {
        return (
            <Container autocomplete="on" onSubmit={this.props.handleSubmit}>
                <MultipleGroupLastLarge>
                    <Field
                        name="prevAddress"
                        onBlur={() => this.checkForBlurError('prevAddress')}
                        submissionError={this.state.errors.includes('prevAddress')}
                        clearSubmitErrors={this.clearSubmitErrors}
                        component={InputGroup}
                        type="text"
                        label="Prev Street No & Street"
                        placeholder="Street No & Street"
                        autocomplete="off"
                    />
                    <Field
                        name="prevUnit"
                        component={InputGroup}
                        type="text"
                        label="Prev Unit"
                        placeholder="Unit"
                        autocomplete="off"
                    />
                </MultipleGroupLastLarge>
                <MultipleGroupFull>
                    <Field
                        name="prevHomeCity"
                        onBlur={() => this.checkForBlurError('prevHomeCity')}
                        submissionError={this.state.errors.includes('prevHomeCity')}
                        clearSubmitErrors={this.clearSubmitErrors}
                        component={InputGroup}
                        type="text"
                        label="Prev City"
                        placeholder="City"
                        autocomplete="off"
                    />
                </MultipleGroupFull>
                <MultipleGroupFull>
                    <Field
                        name="prevStateId"
                        onBlur={() => this.checkForBlurError('prevStateId')}
                        submissionError={this.state.errors.includes('prevStateId')}
                        clearSubmitErrors={this.clearSubmitErrors}
                        component={DropDownSelect}
                        options={this.props.states}
                        defaultOption={'Choose'}
                        label="Prev State"
                        type="text"
                    />
                    <Field
                        name="prevPostalCode"
                        onBlur={() => this.checkForBlurError('prevPostalCode')}
                        submissionError={this.state.errors.includes('prevPostalCode')}
                        clearSubmitErrors={this.clearSubmitErrors}
                        component={InputGroup}
                        type="text"
                        label="Prev Postal code"
                        placeholder="Postal Code"
                        autocomplete="off"
                        maxLength={5}
                    />
                </MultipleGroupFull>
                <ButtonGroupWrapper>
                    <TwoGroup>
                        <Button label="Back" onClick={this.props.onBack} />
                        <Button
                            primary={true}
                            type="submit"
                            label="Continue"
                            disabled={this.props.invalid}
                            onClick={this.showAllErrors}
                        />
                    </TwoGroup>
                </ButtonGroupWrapper>
            </Container>
        );
    }
}

VoteRegistrationStep7Form.propTypes = {
    onBack: PropTypes.func,
    invalid: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func,
    states: PropTypes.array,
    validationErrors: PropTypes.object
};

export default compose(
    connect((state,props) => ({
        initialValues: {},
        validationErrors: Object.keys(props.validationErrors || {})
    })),
    reduxForm({
        form: 'voteRegistrationStep7Form',
        validate: validateStep7,
        destroyOnUnmount: false
    })
)(VoteRegistrationStep7Form);
